module.exports = __webpack_public_path__ + "static/media/bac-checkmark.b2e0af4f.svg";